
import Vue from 'vue'
import PunktBlock from '../punkt-block/punkt-block.vue'
import staticBlockMixin from '~/mixins/staticBlockMixin'

export default Vue.extend({
  name: 'PunktListBlock',
  components: { PunktBlock },
  mixins: [staticBlockMixin],

  props: {
    reverse: {
      type: Boolean,
      default: false
    },

    listIconStyle: {
      type: Boolean,
      default: false
    },

    useSmallContainer: {
      type: Boolean,
      default: false
    },

    splitColumns: {
      type: Boolean,
      default: false
    }
  },

  computed: {
    splitedList () {
      // Вычисляем размер каждой части
      const partSize = Math.floor(this.blocks.length / 2)
      const remainder = this.blocks.length % 2

      // Инициализируем результат
      const result = {}

      // Инициализируем индексы начала и конца
      let start = 0

      for (let i = 1; i <= 2; i++) {
        // Определяем конец текущей части
        const end = start + partSize + (i <= remainder ? 1 : 0)

        // Добавляем часть в результат
        result[i] = this.blocks.slice(start, end)

        // Обновляем начало для следующей части
        start = end
      }

      return result
    }
  }
})
